import { i18n } from '../locales'

function statusMap(value) {
  switch (value) {
    case 'paid':
      return i18n.t('dashboard.dividends.paid')
    case 'forecast':
      return i18n.t('dashboard.dividends.forecast')
    default:
      return i18n.t('dashboard.dividends.default')
  }
}

function periodMap(s) {
  if (i18n.locale == 'en')
    return String(s)
      .replace('год', 'annual')
      .replace('спец', 'special')
      .replace('КВ', 'Q')
      .replace('П', 'H')
      .replace('М', 'M')
  // russian М to eng M
  else return s
}

export { statusMap, periodMap }
